package fr.xibalba.generateurClassesLycee

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase

@InitSilk
fun initSilk(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("*") {
        Modifier.fontFamily("Montserrat", "Arial", "Verdana", "Geneva", "Helvetica", "sans-serif")
    }
    ctx.stylesheet.registerStyleBase("html, body") { Modifier.fillMaxHeight() }
}